const normalize = value => String(value || '').toLocaleLowerCase('en')
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const stableSort = (rows, field, direction = 'asc') => rows
  .map((row, index) => ({ row, index }))
  .sort((left, right) => {
    const a = left.row[field]; const b = right.row[field];
    const numeric = !Number.isNaN(Number(a)) && !Number.isNaN(Number(b));
    const comparison = numeric ? Number(a) - Number(b) : String(a || '').localeCompare(String(b || ''));
    return (comparison === 0 ? left.index - right.index : comparison) * (direction === 'desc' ? -1 : 1);
  }).map(entry => entry.row);

export const applyCustomerFilters = (rows, filters = {}) => rows.filter(row => {
  if (filters.search && !normalize(`${row.name} ${row.country}`).includes(normalize(filters.search))) return false;
  if (filters.status && filters.status !== 'ALL' && row.status !== filters.status) return false;
  if (filters.country && filters.country !== 'ALL' && row.country !== filters.country) return false;
  if (filters.movement === 'POSITIVE' && Number(row.mrrDelta) <= 0) return false;
  if (filters.movement === 'NEGATIVE' && Number(row.mrrDelta) >= 0) return false;
  if (filters.missingContact && row.relatedAccountId) return false;
  return true;
});

export const applyOpportunityFilters = (rows, filters = {}) => rows.filter(row => {
  const searchable = `${row.company} ${row.owner} ${row.contactName} ${row.contactEmail} ${row.nextAction}`;
  if (filters.search && !normalize(searchable).includes(normalize(filters.search))) return false;
  if (filters.stage && filters.stage !== 'ALL' && row.stage !== filters.stage) return false;
  if (filters.severity && filters.severity !== 'ALL' && row.priority?.severity !== filters.severity) return false;
  return true;
});
